import { objectToQueryString } from '@/common/js/utils';
import { httpManager as http } from '@/plugins/HttpManager';
import {
    IApprovePaymentRes,
    IBillingAgreementItem,
    ICommonRes,
    ICreateBillingAgreementSessionRes,
    ICreatePaymentSessionArgs,
    ICreatePaymentSessionRes,
    IGetPaymentMethodsArgs,
    IGetPaymentMethodsRes,
    TCancelPaymentRes,
    TGetPaymentResultRes,
} from '@reolink-cloud/interface';

export const getPaymentsMethods = async ( args?: IGetPaymentMethodsArgs ): Promise<IGetPaymentMethodsRes> => {

    const { data } = await http.get<IGetPaymentMethodsRes>( `/shop/order/payment/methods${objectToQueryString( args ?? {})}` );

    return data;

};

export const createPayment = async ( args: ICreatePaymentSessionArgs ): Promise<ICreatePaymentSessionRes> => {

    const { data } = await http.post<ICreatePaymentSessionRes>( `/shop/orders/payment/`, args, {

        frequency: 0.25

    });
    return data;

};

/**
 * 支付确认
 */
export const approval = async(
    payment?: string, paymentId?: string, extraData?: any
): Promise<IApprovePaymentRes> => {

    const { data } = await http.post<IApprovePaymentRes>( `/shop/order/payments/approval/`, {

        payment, paymentId, extraData

    });

    return data;

};

export const cancelPayment = async ( id: string ): Promise<TCancelPaymentRes> => {

    const { data } = await http.post<TCancelPaymentRes>( `/shop/order/payments/cancellation`, {
        payment: id
    });

    return data;

};

/** 获取支付结果 */
export const queryPaymentResult = async ( id: string, payment: string, isPaymentId?: boolean ): Promise<TGetPaymentResultRes> => {

    const { data } = await http.get<TGetPaymentResultRes>( `/shop/order/${id}/payment/${payment}/result${isPaymentId ? `?payment_id=${payment}` : ''}`  );

    return data;

};

/**
 * 初始化支付合约签订会话
 */
export const initBillingAgreementSession = async ( args: {
    /**
    * 服务唯一 id，用于标记唯一的云服务实例
    */
    serviceId: string;
}): Promise<ICreateBillingAgreementSessionRes> => {

    const { serviceId } = args;
    const { data } = await http.post<ICreateBillingAgreementSessionRes>( '/shop/payment/billing/agreements/session', {
        serviceId
    });

    return data;

};

/**
 * 创建支付合约 token
 */
export const createBillingAgreementToken = async (): Promise<void> => {

    await http.post( '/shop/payment/billing/agreements/token', {});

};

/** 获取用户的 支付合约列表 */
export const getBillingAgreementList = async (): Promise<ICommonRes<IBillingAgreementItem>> => {

    const { data } = await http.get<ICommonRes<IBillingAgreementItem>>( '/shop/payment/billing/agreements' );

    return data;

};
